<template>
  <div class="indicator-style-icon" :style="iconStyle">
    <i :class="chartData.styleConfig.helperData.indicatorRowIconMap[rowKey]"></i>
  </div>
</template>

<script>
import { hexToRgba } from '../../../utils/index'
import { getCategoryDimension } from '../../../utils/utils'
export default {
  name: 'styleIcon',
  props: {
    chartData: {
      type: Object,
      default: () => { },
    },
    rowValue: {
      type: String,
      default: '',
    },
    idx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      themeColorList: ['#407FFF', '#37D4CF', '#A091F2', '#FFB779', '#7C7CA6', '#34CC98']
    }
  },
  computed: {
    rowKey() {
      const {rows,values} = getCategoryDimension(this.chartData.fields)
      return rows.length > 0 ? this.rowValue : values[0]
    },
    iconStyle() {
      const colorIndex = this.idx % this.themeColorList.length
      const themeColor = this.themeColorList[colorIndex]
      const backgroundColor = hexToRgba(themeColor, 0.2)

      return {
        backgroundColor: backgroundColor,
        color: themeColor
      }
    }
  },
  methods: {
  },
}
</script>

<style scoped lang="less">
.indicator-style-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 63px;
  height: 63px;
  border-radius: 50%;

  i {
    font-size: 33px;
  }
}
</style>